import $ from 'jquery';
import MenuWidget from '../../components/menu-widget';
$(() => {
    MenuWidget.init();
});
